import { NgModule } from '@angular/core';
import { AppSpinnerComponent } from './appspinner.component';
@NgModule({
    declarations: [AppSpinnerComponent],
    exports: [AppSpinnerComponent]
})
export class AppSpinnerModule { }